type IconName = "todo" | "done" | "schedules" | "upgrades" | "add" | "camera" | "back" | "close" | "retake" | "library" | "bang" | "repeat" | "pin" | "pinned" | "remove" | "bell" | "bell-ringing" | "profile" | "coin" | "wood" | "flame";

/** Decorative art; the surrounding control supplies its accessible name. */
export function PixelIcon({ name, className = "" }: { name: IconName; className?: string }) {
  const small = name === "coin" || name === "wood" || name === "flame";
  const size = small ? 12 : 24;
  const height = name === "flame" ? 16 : size;
  const file = small ? name : `icon-${name}`;
  // The pin is a 36 px drawing shown at 24 CSS px, so the 1x file already gives 2 device pixels per art pixel on 3x screens; the @3x twin would be downscaled unevenly.
  // The pinned pin (scripts/make-pin.mjs), the scroll's Remove (scripts/make-remove.mjs) and the alarm bells (scripts/make-bell.mjs) are 12 art pixels
  // shown at 24: the 1x file, two CSS pixels an art pixel.
  const src = name === "pin" || name === "pinned" || name === "remove" || name === "bell" || name === "bell-ringing" ? `/ui/${file}.png` : `/ui/${file}@3x.png`;
  return <img class={`pixel-icon ${className}`} src={src} width={size} height={height} alt="" aria-hidden="true" />;
}

export function Divider() {
  return <img class="pixel-divider" src="/ui/divider@3x.png" width={120} height={10} alt="" aria-hidden="true" />;
}

export function Logotype() {
  return <h1 class="brand-heading"><img class="logotype" src="/ui/logotype@3x.png" width={300} height={90} alt="Omie's Peons" /></h1>;
}
